import type { PurdueLevel } from '@/types';

export interface PurdueLevelInfo {
  level: PurdueLevel;
  name: string;
  description: string;
}

export const PURDUE_LEVELS: PurdueLevelInfo[] = [
  {
    level: 0,
    name: 'L0 - Physical Process',
    description:
      'Field instrumentation: sensors, actuators, valves directly in the physical process.',
  },
  {
    level: 1,
    name: 'L1 - Basic Control',
    description:
      'PLCs, RTUs, IEDs, safety systems controlling the physical process.',
  },
  {
    level: 2,
    name: 'L2 - Supervisory Control',
    description: 'HMIs, SCADA workstations, area-level supervisory systems.',
  },
  {
    level: 3,
    name: 'L3 - Operations',
    description:
      'DMZ, historians, MES, engineering workstations, plant operations IT.',
  },
  {
    level: 4,
    name: 'L4 - Enterprise',
    description: 'Business networks, ERP, corporate IT.',
  },
  {
    level: 5,
    name: 'L5 - Internet',
    description: 'Vendor portals, remote access, cloud services.',
  },
];

export function levelInfo(level: PurdueLevel): PurdueLevelInfo {
  return PURDUE_LEVELS[level]!;
}
